import { render, staticRenderFns } from "./ed-class-builder-sidebar.component.vue?vue&type=template&id=18702a95&scoped=true&"
import script from "./ed-class-builder-sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-sidebar.component.scss?vue&type=style&index=0&id=18702a95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18702a95",
  null
  
)

export default component.exports